/* global $ */
/* global debugConsole */

import ShopgateSubscriptionProduct from './shopgate-subscription-product';
import TaggedLogger from '../debug/tagged-logger';

const logger = new TaggedLogger('SubscriptionProduct', 'color: lightgreen;');
const activeComponentName = 'subscription_product';

/**
 * Product details script plugin that creates a possibility to checkout a product as
 * a recurring order.
 *
 * @param {SGProductDetailsCore} core - Instance of SGProductDetailsCore
 * @returns {*}
 */
const shopgateSubscriptionProductPlugin = function (core) {
  const that = this;

  let $containerSubscriptionProduct = null;
  let subscriptionSelect = null;
  let $addToCartButton = null;
  let $checkoutButton = null;
  let parentSubscriptionId = null;
  const SGSubscription = ShopgateSubscriptionProduct();

  /**
   * Handle the select build
   * @param {number} subscriptionId - subscription id
   */
  function buildSelect(subscriptionId) {
    $containerSubscriptionProduct.empty();

    SGSubscription.setSubscriptionId(subscriptionId);

    if (subscriptionId) {
      logger.info(`Building select for subscription id ${subscriptionId}`);

      subscriptionSelect = SGSubscription.buildSelect();
      subscriptionSelect.bind('change', function () {
        logger.info('updateSubscriptionType started');
        logger.info(`Subscription frequency chosen: ${$(this).val()}`);
        // Getting value from changed select state. Value is string. !!"0" === true.
        core.setState('subscriptionTypeChosen', !!parseInt($(this).val(), 10), true);
      });

      $containerSubscriptionProduct.append(subscriptionSelect);
      subscriptionSelect.selectpicker({
        style: 'btn-default',
        dropupAuto: true,
        showSubtext: true,
      });

      logger.info('Created subscription select from subscription setting',
        core.getComponentVars(activeComponentName).subscriptions[subscriptionId]
      );
    } else {
      logger.info('No subscription select created');
    }
    // Getting value from default select state. Value is string. !!"0" === true.
    core.setState('subscriptionTypeChosen', !!parseInt($(subscriptionSelect).val(), 10));
    core.setState('isProductSubscriptionEnabled', !!subscriptionId, true);
  }

  /**
   * Click event callback for checkout button
   * @param {Object} e - event object
   * @returns {boolean}
   */
  function subscriptionClickEvent(e) {
    e.preventDefault();
    // Call the SGSubscription module to do the add to cart
    SGSubscription.addItemToCart(
      core.getSelectedProduct().product.product_number,
      core.getSelectedValues().quantity,
      subscriptionSelect.val()
    );
    return false;
  }

  /**
   * Copy add to cart btn and insert after the add to cart button
   */
  function initCheckoutButton() {
    if ($checkoutButton) {
      $checkoutButton.remove();
    }

    $checkoutButton = $addToCartButton
      .clone()
      .removeClass('locked disabled')
      .removeAttr('id')
      .on('click.productSubscription', subscriptionClickEvent);

    $checkoutButton.insertAfter($addToCartButton);

    $checkoutButton
      .hide()
      .find('span')
      .html($.i18n._('common_checkout'));
  }

  /**
   * Plugin initialization.
   * Define all the required variables the script works with.
   * Build the UI Element and set initial states.
   * @param {string} callType - products.ui
   * @param {Object} data - initial product data
   */
  that.onCoreInit = function (callType, data) {
    const endpoints = core.getComponentUrls(activeComponentName);
    const options = core.getComponentVars(activeComponentName);

    $containerSubscriptionProduct = $('.container-product-subscription').empty();
    $addToCartButton = $('#add-to-cart');

    initCheckoutButton();

    $containerSubscriptionProduct.addClass('row product-frame');
    logger.info('Setting endpoint', endpoints);
    logger.info('Setting options', options);

    SGSubscription.setEndpoints(endpoints);
    SGSubscription.setOptions(options);

    parentSubscriptionId = SGSubscription.getSubscriptionIdFromData(data.products.parent.product);
    if (parentSubscriptionId) {
      logger.info('Subscription select is build for parent item');
    }

    buildSelect(parentSubscriptionId);
  };

  /**
   * Check the updated product if it is a subscription product (depending on the product-tag).
   * Set the states isProductSubscriptionEnabled and subscriptionTypeChosen
   * @param {string} callType - products.ui
   * @param {Object} data - product data of the currently updated product
   */
  that.onUpdateProduct = function (callType, data) {
    const subscriptionId = parentSubscriptionId
      || SGSubscription.getSubscriptionIdFromData(data.product.product);

    /* If the subscription id is not stored in the parent data,
     we need to handle each product individually */
    if (!parentSubscriptionId) {
      logger.info('Check if child product is subscription product ', data.product.product);
      buildSelect(subscriptionId);
    }
  };

  /**
   * Is called on any setState trigger.
   * Checks the current states isProductSubscriptionEnabled and subscriptionTypeChosen and
   * and manipulates the add to cart button, so it it is hidden and the cart a subscription payment.
   *
   * @param {string} callType - products.ui
   * @param {Object} currentStates - Object of all the current states
   */
  that.onUpdateStates = function (callType, currentStates) {
    const subscriptionSelected =
          currentStates.isProductSubscriptionEnabled && currentStates.subscriptionTypeChosen;

    // If selection is done and a subscription product is selected change the buttons
    if (subscriptionSelected && !currentStates.cartButtonLocked) {
      $addToCartButton.hide();
      $checkoutButton.show();
      logger.info('Showing button to subscription checkout', $checkoutButton[0]);
    } else {
      $addToCartButton.show();
      $checkoutButton.hide();
    }

    // Show or hide the subscription selection
    $containerSubscriptionProduct.toggle(currentStates.isProductSubscriptionEnabled);

    logger.info('Subscription container is hidden: ', $containerSubscriptionProduct.is(':hidden'));
    logger.info('Subscription checkout button is hidden: ', $checkoutButton.is(':hidden'));

    logger.info('updateSubscriptionType - finished');
  };

  /**
   * Plugin constructor
   * @returns {shopgateSubscriptionProductPlugin} plugin
   */
  function init() {
    that.vendor = 'Shopgate';
    that.name = 'ShopgateSubscriptionProductPlugin';
    that.type = ['products.ui'];
    return that;
  }

  return init();
};

if (typeof window.ShopgateProductDetailsCore === 'object' &&
  typeof window.ShopgateProductDetailsCore.registerPlugin === 'function') {
  if (window.ShopgateProductDetailsCore.isComponentActive(activeComponentName)) {
    window.ShopgateProductDetailsCore.registerPlugin(shopgateSubscriptionProductPlugin);
  }
} else {
  logger.error('No instance of "ShopgateProductDetailsCore" found');
}



// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/shopgate-subscription-product-plugin.js